var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"analysis-title flex flex-m"},[_c('i',{class:_vm.beforeIcon}),_vm._t("default"),_c('el-popover',{attrs:{"placement":"bottom","trigger":"hover","popper-class":"analysis-popover"}},[_vm._t("content"),_c('i',{class:_vm.afterIcon,attrs:{"slot":"reference"},slot:"reference"})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }